import {
    Box,
    Checkbox,
    Grid,
    Hidden,
    IconButton,
    Theme,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {
    BlackDownArrowIcon,
    BlueEditIcon,
    DeleteIcons,
    FundTransferArrow
} from "../assets/SvgIcons";
import SchemeCard from "./SchemeCard";
import { toINR } from "../utils/utilityFunctions";
import { useSelector } from "react-redux";
import { RootStateType } from "../redux-store/reducers";

export type PaymentItemProps = {
    orderDetails: Array<{ label: string, value: string }>;
    fromSchemeName: string;
    toSchemeName: string;
    amcId: string;
}

export default function PaymentItemInfo({
    orderDetails,
    fromSchemeName,
    toSchemeName,
    amcId
}: PaymentItemProps): JSX.Element {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    console.log('orderDetails', orderDetails);
    return (
        <>
            <Hidden lgUp>
                <Box>
                    <Grid
                        container
                        flexWrap="nowrap"
                        sx={{ columnGap: "15px" }}
                    >
                        <Grid
                            item
                            container
                            xs={10}
                            flexWrap="nowrap"
                            sx={{ columnGap: "15px" }}
                        >
                            <Grid
                                item
                                container
                                flexDirection="column"
                                sx={{ rowGap: "10px" }}
                            >
                                <SchemeCard
                                    schemeName={fromSchemeName}
                                    amcId={amcId}
                                />
                                {toSchemeName && (
                                    <>
                                        <BlackDownArrowIcon />
                                        <SchemeCard
                                            schemeName={toSchemeName}
                                            amcId={amcId}
                                        />
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box sx={{ marginTop: "35px" }}>
                        {orderDetails.map((obj) => (
                            <Grid
                                key={obj.label}
                                container
                                sx={{ marginBottom: "25px" }}
                            >
                                <Grid item xs={5}>
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px",
                                            color: theme.palette.text.secondary
                                        })}
                                    >
                                        {obj.label}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography
                                        variant="body_600"
                                        sx={(theme: Theme) => ({
                                            fontSize: "16px",
                                            color: theme.palette.text.primary,
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px",
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            textAlign: 'right',
                                        })}
                                    >
                                        {obj.value}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Box>
                </Box >
            </Hidden>
            <Hidden lgDown>
                <Box sx={{ padding: '0 25px' }}>
                    <Grid
                        container
                        flexWrap="nowrap"
                        sx={{ columnGap: "15px" }}
                    >
                        <Grid
                            item
                            container
                            xs={12}
                            flexWrap="nowrap"
                            sx={{ columnGap: "15px" }}
                        >
                            <Grid
                                item
                                xs={toSchemeName ? 5 : 12}
                            >
                                <SchemeCard
                                    schemeName={fromSchemeName}
                                    amcId={amcId}
                                />
                            </Grid>
                            {toSchemeName && (
                                <>
                                    <Grid
                                        item
                                        container
                                        xs={2}
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        <FundTransferArrow />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <SchemeCard
                                            schemeName={toSchemeName}
                                            amcId={amcId}
                                        />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        sx={{
                            marginTop: "25px",
                            rowGap: '30px',
                        }}
                    >
                        {orderDetails.map((obj) => (
                            <Grid
                                item
                                container
                                xs={4}
                                key={obj.label}
                                sx={{
                                    rowGap: "8px",
                                    paddingRight: "30px"
                                }}
                            >
                                <Grid item xs={12}>
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px",
                                            color: theme.palette.text.secondary,
                                        })}
                                    >
                                        {obj.label}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography
                                        variant="body_600"
                                        sx={(theme: Theme) => ({
                                            fontSize: "16px",
                                            color: theme.palette.text.primary,
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px",
                                        })}
                                    >
                                        {obj.value}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Hidden>
        </>
    )
}
